import React from 'react';

const cf = (
	<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px"
     viewBox="0 0 1366 768" style={{enableBackground:"new 0 0 1366 768"}} >
	<polygon points="461.5,246.5 488.5,291.5 589.5,301.5 600.5,340.5 539.5,338.5 560.5,372.5 612.5,373.5 
    672.5,553.5 733.5,372.5 782.5,372.5 806.5,339.5 743.5,342.5 754.5,301.5 856.5,290.5 886.5,244.5 724.5,271.5 673.5,448.5 
    623.5,271.5 "/>
	</svg>)

export default cf;


// WEBPACK FOOTER //
// ./src/components/Websites/About/SVGs/codefights.js